import { render, staticRenderFns } from "./aprovados.vue?vue&type=template&id=54474c0d&scoped=true"
import script from "./aprovados.vue?vue&type=script&lang=js"
export * from "./aprovados.vue?vue&type=script&lang=js"
import style0 from "./aprovados.vue?vue&type=style&index=0&id=54474c0d&prod&scoped=true&lang=css"
import style1 from "./aprovados.vue?vue&type=style&index=1&id=54474c0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54474c0d",
  null
  
)

export default component.exports